export default __webpack_public_path__ + "static/media/bacon.9a178aa8.jpg";